import React from "react";

const NavListItem = (props) => {
    return (
        <li>{props.title}</li>
    )
}

export default NavListItem;
